
import { useState } from "react"
import UploadImg from "../../../components/Upload/UploadImg"
import { useFoods } from "./FoodsStore"
import { Button, Form, Input } from "antd"

const Add = () => {
    const [img, setImg] = useState(null)
    const [form] = Form.useForm()

    console.log(img);
    

    const { addFood } = useFoods()
    return (
        <Form onFinish={(values) => {
            values.img = img
            addFood(values)
        }} layout="vertical">
            <Form.Item name="name" label="Nomi">
                <Input />
            </Form.Item>
            <Form.Item name="price" label="Narxi">
                <Input type="number" />
            </Form.Item>
            <Form.Item name="note" label="Tavsifi">
                <Input />
            </Form.Item>
            <Form.Item name="img" label="Rasm">
                <UploadImg setImgurl={setImg} imageUrl={img} />
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    )
}

export default Add